export const downloadAsFile = (url: string, fileName: string) => {
  const anchor = document.createElement('a');
  // @ts-ignore
  anchor.style = 'display: none';
  document.body.appendChild(anchor);
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  setTimeout(() => {
    window.URL.revokeObjectURL(url);
    document.body.removeChild(anchor);
  });
};
